import { Box, Flex, FormControl, FormHelperText, FormLabel, Input, InputGroup, InputLeftElement, Select, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Spacer, Stack } from '@chakra-ui/react';
import React from 'react';
import { updateForm } from '../../store/formReducer';
import { useStore } from '../../store/Store';
// import SliderForm from './sliderForm';
import { checkAmount } from '../../utils/numberUtils';

function CoumpoundForm() {
    const [state, dispatch] = useStore();
    const {amount, compoundingInterval} = state;

    return (
        <Stack>
            <Flex direction="column">
                <form>
                    <Box my="4" >
                    <FormControl key="amount" id="amount">
                        <FormLabel>Amount</FormLabel>
                        <InputGroup>
                        <InputLeftElement
                        pointerEvents="none"
                        color="gray.300"
                        fontSize="1em"
                        children="₹"
                        />
                        <Input  type="number" value = {amount}
                        // autoFocus="autoFocus"
                        autoComplete="off"
                        onChange={ event =>
                            dispatch(updateForm('amount', event.currentTarget.value))
                        }
                        />
                    </InputGroup>
                        { checkAmount(amount) && <FormHelperText color="red.300" textAlign="left">Amount should be greater than 10</FormHelperText>}
                    </FormControl>
                    </Box>
                    <Box my="4" >
                    <FormControl id="compoundingInterval" key="compoundingInterval">
                        <FormLabel>Coumpounding Interval</FormLabel>
                        <Select placeholder="Select option" value={compoundingInterval}
                        // onChange={event => setCompoundingInterval(event.currentTarget.value)}
                        onChange={ event =>
                            dispatch(updateForm('compoundingInterval', event.currentTarget.value))
                        }
                        >
                            <option value="12">12</option>
                            <option value="4">4</option>
                            <option value="2">2</option>
                            <option value="1">1</option>
                        </Select>
                    </FormControl>
                    </Box>
                    <Box my="4" >
                    <FormControl id="investment_period" key="investment_period">
                        <FormLabel>  
                        <Flex> 
                            <span>
                            Investment Period
                            </span>
                            <Spacer />
                            <span>
                            {state.period} years
                            </span>
                        </Flex>
                        </FormLabel>
                        <Slider aria-label="investment_period_slider" max={60} min={1}
                        defaultValue={state.period}
                        onChange={ (val) =>
                            dispatch(updateForm('period', val))
                        }
                        // onChangeEnd={ (val) =>
                        //     dispatch(updateForm('period', val))
                        // }
                        >
                            <SliderTrack>
                                <SliderFilledTrack />
                            </SliderTrack>
                            <SliderThumb />
                        </Slider>
                    </FormControl>
                </Box>
                <Box my="4" >
                    <FormControl id="rate" key="rate">
                        <FormLabel>
                        <Flex> 
                            <span>
                            Rate of Return
                            </span>
                            <Spacer />
                            <span>
                            {state.rate} %
                            </span>
                        </Flex>
                        </FormLabel>
                        <Slider aria-label="rate_of_return_slider"
                        defaultValue={state.rate}
                        onChange={ (val) =>
                            dispatch(updateForm('rate', val))
                        }
                        // onChangeEnd={ (val) =>
                        //     dispatch(updateForm('rate', val))
                        // }
                        max={50} min={1}
                        // value={rate}
                        >
                            <SliderTrack key="rateSlider">
                                <SliderFilledTrack key="rateFilledSlider"/>
                            </SliderTrack>
                            <SliderThumb key="rateSliderThumb"/>
                        </Slider>
                    </FormControl>
                </Box>
            </form>                
        </Flex>
    </Stack>
    )
}

export default CoumpoundForm
